export default "__VITE_ASSET__CQ77Ddf9__"